import { FC, useContext } from "react";

import { BVLogo } from "../../assets";
import { FooterTextProps } from "./types";
import { AuthContext } from "src/context/authContext";


const FooterText: FC<FooterTextProps> = ({ footerType }): JSX.Element => {
  const { isUserAuthorized } = useContext(AuthContext);

  return (
    <div className={`${!isUserAuthorized ? '' : 'after-login-trademark p-3'}`}>
      <div className="trademark-body container-fluid">
        <div className="row">
          <div className="col-12 col-sm-2 col-md-2">
            <img className="img-fluid" width={300} src={BVLogo} alt="Products Logos" />
          </div>
          <p className="copyright-text mb-1 col-12 col-sm-10 col-md-10">
            This site is intended for US health care professionals. StimRouter is a registered trademarks of Bioness Inc.
            All other trademarks are property of their respective owners. ©2021 Bioventus LLC
          </p>
        </div>
      </div>
    </div>
  );
};

export default FooterText;
